import React, { memo } from "react";

// Style
import "./InfoText.scss";

// Classnames
import clsx from "clsx";

// Components
import Img from "../Img";

interface IInfoText {
  text?: string,
  title?: string,
  subTitle?: string,
  className?: string,
  isHiddeText?: boolean,
  children?: React.ReactNode,
  classNameTitle?: string,
}

export const InfoText: React.FC<IInfoText> = memo((props) => {
  const {
    text,
    title,
    subTitle,
    children,
    className,
    isHiddeText,
    classNameTitle
  } = props;

  const cn = clsx(
    "info-text mb10 relative",
    className ? className : ""
  );

  const cnTitle = clsx(
    "info-text__title",
    classNameTitle ? classNameTitle : ""
  );

  return <>
    <div className={cn}>
      <Img
        isSvg
        name="infoSvg"
        className="info-text__icon"
      />

      {title ? <p className={cnTitle}>
          {title}
        </p>
        : <p className={cnTitle}>
          The final price may vary depending on the packaging requirements, region of shipping, and applied discounts.
          You will receive an invoice via email after careful revision by our manager. Please use Order Notes to provide
          us with any additional information including personal discounts and specific delivery options.
        </p>}

      {subTitle && <p className="info-text__sub-title">
        {subTitle}
      </p>}
    </div>

    {children}

    {!isHiddeText ? !!text ?
      <p className="info-text__text mb30">
        {text}
      </p>
      : <p className="info-text__text mb30">
        Your personal data will be used to process your order, support your experience throughout this website, and
        for other purposes described in our <a href="https://ebc.enamine.net/privacy-policy" target="_blank">privacy
        policy</a>.
      </p> : null}
  </>;
});

export default InfoText;
